import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { editPackaging } from './editPackaging';
import { createPackaging } from './createPackaging';

export const workflows: WorkflowOptions[] = [
  editPackaging,
  createPackaging,
  ...Object.values(generateAssetStatusWorkflow('packaging')),
];

export default workflows;
